$mol_view_tree2_to_js_test_ex_simple_nan_foo $mol_object
	a NaN
	b +NaN
	c -NaN
	d +Infinity
	e -Infinity
	f Infinity

